import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';

export const getVerottajailmoitettavaProjectsOfUser = async (
  { activeEmployerInfo = {}, isLocalApiRequest = false } = {}
) => {
  const apiPath = `user/projects/verottajailmoitettava-project-ids`;

  const signedRequest = await createSignedGetRequest({
    apiPath,
    activeEmployerInfo,
    isLocalApiRequest,
  });

  const response = await axios(signedRequest);

  return response.data;
};
